import MoneroRpcConnection from "../../common/MoneroRpcConnection";
/**
 * Configuration to connect to monerod.
 */
export default class MoneroDaemonConfig {
    /**
     * Construct a configuration to open or create a wallet.
     *
     * @param {Partial<MoneroDaemonConfig>} [config] - MoneroDaemonConfig to construct from (optional)
     * @param {string|Partial<MoneroRpcConnection>} [config.server] - uri or MoneroRpcConnection to the daemon (optional)
     * @param {boolean} [config.proxyToWorker] - proxy daemon requests to a worker (default true)
     * @param {string[]} [config.cmd] - command to start monerod (optional)
     * @param {number} [config.pollInterval] - interval in milliseconds to poll the daemon for updates (default 20000)
     */
    constructor(config) {
        Object.assign(this, config);
        if (this.server)
            this.setServer(this.server);
        this.setProxyToWorker(this.proxyToWorker);
    }
    copy() {
        return new MoneroDaemonConfig(this);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (json.server)
            json.server = json.server.toJson();
        return json;
    }
    getServer() {
        return this.server;
    }
    setServer(server) {
        if (server && !(server instanceof MoneroRpcConnection))
            server = new MoneroRpcConnection(server);
        this.server = server;
        return this;
    }
    getProxyToWorker() {
        return this.proxyToWorker;
    }
    setProxyToWorker(proxyToWorker) {
        this.proxyToWorker = proxyToWorker;
        return this;
    }
    getCmd() {
        return this.cmd;
    }
    setCmd(cmd) {
        this.cmd = cmd;
        return this;
    }
    getPollInterval() {
        return this.pollInterval;
    }
    setPollInterval(pollInterval) {
        this.pollInterval = pollInterval;
        return this;
    }
}
